import { Box, useStyleConfig } from "@chakra-ui/react";

const CardFooter = (props: any) => {
	const { variant, children, ...rest } = props;
	const styles = useStyleConfig("CardFooter", { variant });

	return (
		<Box __css={styles} {...rest}>
			{children}
		</Box>
	);
}

export default CardFooter;
